import clsx from 'clsx';
import { forwardRef } from 'react';
import { ButtonProps, Ref } from './types/buttonCustom';
import { Loader } from 'components/Loader';

const Button = forwardRef<Ref, ButtonProps>((props, ref) => {
  const {
    variant = 'filled',
		isLoading,
    type = 'button',
    className,
    children,
    ...rest
  } = props;

  return (
    <button
      type={type}
      ref={ref}
      className={clsx(
        'rounded-8 h-[45px] px-[20px] flex items-center justify-start font-Inter disabled:text-black-50 shadow-md transition-colors text-sm font-[500]',
        variant === 'filled' &&
          ' bg-blue border-[1px] border-white text-white hover:bg-[#8C96FF] active:bg-[#1E31FF] disabled:bg-blue-light disabled:shadow-none disabled:border-transparent',
        variant === 'bordered' &&
          'border-[1px] border-blue hover:bg-blue-light-10 dark:hover:bg-blue-darkMode-20 active:bg-blue-light-20 ',
        className
      )}
      {...rest}
    >
      {isLoading ? <Loader ratio={24}/> : children}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;
